import { Trans, useTranslation } from "react-i18next";
import { getEmailHref } from "js/formatting";
import config from "config/config";

export default function FileAClaimContactUs({ showOtherContact = true }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-1 gap-4 lg:gap-6">
        <div className="ui-card text-sm p-4 xl:p-6">
          <h2 className="text-xl font-body font-bold">
            {t("FNOL-expectCard")}
          </h2>
          <hr className="my-4" />

          <p className="font-semibold">{t("FNOL-expectCard-Title-1")}</p>
          <br />
          <p>{t("FNOL-expectCard-Description-1")}</p>
          <br />

          <p className="font-semibold">{t("FNOL-expectCard-Title-2")}</p>
          <br />
          <p>{t("FNOL-expectCard-Description-2")}</p>
          <br />

          <p className="font-semibold">{t("FNOL-expectCard-Title-3")}</p>
          <br />
          <p>
            <p>{t("FNOL-expectCard-Description-3")}</p>
          </p>
          <br />
          <p>
            {t("FNOL-expectCard-life")}
            <a href="tel:+1-844-953-0347" className="text-black no-underline">
              {t("CustomerHelp-contactAction-phoneNumber-1")}
            </a>
          </p>
          <p>
            {t("FNOL-expectCard-Fixed-annuity")}
            <a href="tel:+1-844-953-2815" className="text-black no-underline">
              {t("CustomerHelp-contactAction-phoneNumber-2")}
            </a>
          </p>
          <p>
            {t("FNOL-expectCard-Variable-annuity")}
            <a href="tel:+1-833-879-0774" className="text-black no-underline">
              {t("CustomerHelp-contactAction-phoneNumber-3")}
            </a>
          </p>
          <br />
          <p>{t("FNOL-expectCardDescription-7")}</p>
          {/* <p className="font-semibold">{t("FNOL-expectCardTitle-4")}</p>
          <br />
          <p>{t("FNOL-expectCardDescription-4")}</p> */}
        </div>
        {showOtherContact && (
          <div className="ui-card p-4 xl:p-6">
            <h2 className="text-xl font-body font-bold">
              {t("FNOL-contactCard")}
            </h2>
            <hr className="my-4" />
            <div className="mb-5">
              <p className="font-semibold">{t("ContactOtherWays-title-4")}</p>
              <p>
                {t("ContactOtherWays-phoneSubTitle-1")}
                <a
                  href="tel:+1-844-953-2815"
                  className="text-black no-underline"
                >
                  {t("CustomerHelp-contactAction-phoneNumber-2")}
                </a>
              </p>
              <p>
                {t("ContactOtherWays-phoneSubTitle-2")}
                <a
                  href="tel:+1-844-953-0347"
                  className="text-black no-underline"
                >
                  {t("CustomerHelp-contactAction-phoneNumber-1")}
                </a>
              </p>
            </div>
            <div className="mb-5">
              <p className="font-semibold">{t("ContactOtherWays-title-1")}</p>
              <p>{t("ContactOtherWays-addressLine-1")}</p>
              <p>{t("ContactOtherWays-addressLine-2")}</p>
              <p>{t("ContactOtherWays-addressLine-3")}</p>
            </div>
            <div className="mb-4">
              <p className="font-semibold">{t("ContactOtherWays-title-2")}</p>
              <p>{t("ContactOtherWays-addressLine-1")}</p>
              <p>{t("ContactOtherWays-addressLine-4")}</p>
              <p>{t("ContactOtherWays-addressLine-3")}</p>
            </div>
            <p className="font-semibold">{t("FNOL-contactCardTitle-4")}</p>
            <div>
              <p>{t("FNOL-contactCardTitle-6")}</p>
            </div>
            <p>
              <Trans
                i18nKey="FNOL-contactCardDescription-4"
                components={{
                  a1: (
                    <a
                      href="tel:1-833-636-0034"
                      className="text-black no-underline"
                    ></a>
                  ),
                  break: <br />,
                }}
              />
            </p>
            <br />
            <p className="font-semibold">{t("FNOL-contactCardTitle-5")}</p>
            <p>
              <a
                href={getEmailHref(config.CUSTOMER_SERVICE_EMAIL)}
                className="no-underline"
              >
                {config.CUSTOMER_SERVICE_EMAIL}
              </a>
            </p>
            <br />
          </div>
        )}
      </div>
    </div>
  );
}
